'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwPod = require('./CwPod.scss');

var _CwPod2 = _interopRequireDefault(_CwPod);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwPod = function CwPod(props) {
  var getTitle = function getTitle() {
    if (props.title || props.ghostTitle || props.titleElements) {
      return _react2.default.createElement(
        'div',
        { className: _CwPod2.default.header },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_CwPod2.default.headerText, (0, _defineProperty3.default)({}, _CwPod2.default.ghostTitle, props.ghostTitle)) },
          props.ghostTitle ? 'pods are lame' : props.title
        ),
        props.titleElements
      );
    }

    return null;
  };

  return _react2.default.createElement(
    'div',
    { 'data-cwid': props.cwId, className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _CwPod2.default.nested, props.nested)) },
    getTitle(),
    _react2.default.createElement(
      'div',
      null,
      props.children
    )
  );
};

CwPod.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Unique id used to identify pod
   */
  podID: _propTypes2.default.string.isRequired,
  /**
   * Optional text to display in title bar
   */
  title: _propTypes2.default.string,
  /**
   * True to include pod title spacing without any text
   * This is used to align pods when they're next to each other
   */
  ghostTitle: _propTypes2.default.bool,
  /**
   * Array of elements to render next to pod title
   */
  titleElements: _propTypes2.default.arrayOf(_propTypes2.default.element),
  /**
   * Whether the pod is nested within another element, such as a grid, and requires indentation.
   */
  nested: _propTypes2.default.bool,
  /**
   * Pod body content
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
};

exports.default = CwPod;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpod/CwPod.js
// module id = 847
// module chunks = 10